import Styles from './ProductAnnouncementBannerAnimation.module.css'

export interface ProductAnnouncementBannerAnimationProps {
  sceneId: string
}

const defaultProps: Partial<ProductAnnouncementBannerAnimationProps> = {}

const ProductAnnouncementBannerAnimation = (props: ProductAnnouncementBannerAnimationProps) => {
  const initializedProps: ProductAnnouncementBannerAnimationProps = {...defaultProps, ...props}
  const {sceneId} = initializedProps

  return <div className={Styles['ProductAnnouncementBannerAnimation']}>Animation for {sceneId}</div>
}

export default ProductAnnouncementBannerAnimation
